// frontend/src/modules/notifications/api.ts
import { api } from '../../core/api-client';
import type { Notification } from './types';

export function listNotifications(opts: { unread?: boolean; limit?: number } = {}): Promise<{ notifications: Notification[] }> {
  const params = new URLSearchParams();
  if (opts.unread) params.set('unread', '1');
  if (opts.limit) params.set('limit', String(opts.limit));
  const qs = params.toString();
  return api<{ notifications: Notification[] }>(`/api/notifications${qs ? `?${qs}` : ''}`);
}

export function unreadCount(): Promise<{ count: number }> {
  return api<{ count: number }>(`/api/notifications/unread-count`);
}

export function markRead(id: string): Promise<{ updated: boolean }> {
  return api<{ updated: boolean }>(`/api/notifications/${id}/read`, { method: 'PATCH' });
}

export function markAllRead(): Promise<{ count: number }> {
  return api<{ count: number }>(`/api/notifications/read-all`, { method: 'POST' });
}
